import { InjectionToken } from '@angular/core';
import { Listener } from '@/types/listener.types';

export const AUTOCLOSE_LISTENERS = new InjectionToken<Listener>('');
